import { useGetLocationSelectItemsLazy } from '@occc-app/dataAccessLayer/location/queries';
import { LazyAutocompleteField } from '@occc/ui-design-system';
import { LocationFilter, LocationSelectItemFragment } from '@occc/graphql';

type LocationSelectFieldProps = {
  name: string;
  label: string;
};

type LocationsResponse = ReturnType<typeof useGetLocationSelectItemsLazy>['response'];

const makeQueryFilter = (inputValue: string): LocationFilter => ({
  search: inputValue || undefined,
});

const mapToFilterFormOptions = (response: LocationsResponse) =>
  response.data?.map((item) => item) || [];

const mapToAutocompleteOption = (item: LocationSelectItemFragment) => ({
  value: item.uuid,
  label: item.siteSystemConfiguration?.[0]?.identifier || '',
  _raw: item,
});

export const LocationMultipleSelectField = ({ name, label }: LocationSelectFieldProps) => {
  return (
    <LazyAutocompleteField
      name={name}
      label={label}
      useLazyQuery={useGetLocationSelectItemsLazy}
      mapQueryResponseToRawArray={mapToFilterFormOptions}
      mapRawResponseItemToAutocompleteOption={mapToAutocompleteOption}
      makeQueryFilter={makeQueryFilter}
      inputProps={{ margin: 'none' }}
    />
  );
};
